import { useTranslation } from "react-i18next";
import TableFilterDynamique, { FilterField } from "components/Common/TableFilter/TableFilterDynamique";
import { useEffect, useMemo, useState } from "react";
import { message } from "antd";
import useRoles from "../hooks/useRoles";
import RolesTable from "../tables/RolesTable";
import AddRoleModal from "../modals/AddRoleModal";
import CustomButton from "components/Common/ui/CustomButton";
import SettingsLayout from "../components/SettingsLayout";

const RolesSettings = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState<any>(null);

  const {
    roles,
    loading,
    error,
    fetchRoles,
    handleCreate,
    handleDelete,
    handleUpdate,
    infoPagination,
  } = useRoles();




  const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});

  useEffect(() => {
    fetchRoles({ page: 1, limit: 10 });
  }, [fetchRoles]);

  useEffect(() => {
    if (error) message.error(error);
  }, [error]);

  const filterFields: FilterField[] = useMemo(
    () => [{ key: "search", label: t("search"), type: "text" }],
    [t]
  );


  const handleFilter = (newFilters: { [key: string]: string | number | null }) => {
    setFilters(newFilters);
    fetchRoles({ ...newFilters, page: 1 });
  };


  const handleSaveRole = async (roleData: any) => {
    if (selectedRole) {
      await handleUpdate(selectedRole.id, roleData);
    } else {
      await handleCreate(roleData);
    }
    setIsModalOpen(false);
  };

  return (
    <SettingsLayout titleKey="roles.title" loading={loading}>
      <div className="d-flex mb-3 justify-content-end gap-2">
        <CustomButton
          onClick={() => {
            setSelectedRole(null); // ensure create mode
            setIsModalOpen(true);
          }}
        >
          <i className="ti ti-plus me-2" />
          {t("roles.create")}
        </CustomButton>

        <TableFilterDynamique
          fields={filterFields}
          filters={filters}
          onApply={(newFilters) => handleFilter(newFilters)}
          onReset={() => handleFilter({ page: 1, limit: 10 })}
        />
      </div>

      <RolesTable
        dataSource={roles}
        loading={loading}
        onDelete={handleDelete}
        onEdit={(role) => { setSelectedRole(role); setIsModalOpen(true); }}
        dataPaginate={{
          current: infoPagination.page,
          pageSize: infoPagination.limit,
          total: infoPagination.total,
        }}
        onChange={(pg) => {
          fetchRoles({
            ...filters,
            page: pg.current!,
            limit: pg.pageSize!,
          });
        }}
      />

      <AddRoleModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedRole(null);
        }}
        onSave={handleSaveRole}
        selectedRole={selectedRole} // if set => edit mode
      />
    </SettingsLayout>
  );
};

export default RolesSettings;
